function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "#45DB5D",
  fillOpacity: 0.15
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.824 12.6721C23.3156 12.6721 25.3354 11.8469 25.3354 10.829C25.3354 9.81117 23.3156 8.98602 20.824 8.98602C18.3325 8.98602 16.3127 9.81117 16.3127 10.829C16.3127 11.8469 18.3325 12.6721 20.824 12.6721Z",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.3353 13.8203C25.3353 14.4419 24.6158 14.9904 23.4502 15.283C22.5947 15.5206 21.7109 15.6363 20.824 15.6267C19.9396 15.6358 19.0582 15.5201 18.2051 15.283C17.061 14.9539 16.3199 14.4053 16.3199 13.8203",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.155 18.6839C21.9211 18.6653 22.6822 18.5523 23.4215 18.3474C24.5655 18.011 25.3138 17.4625 25.3138 16.8481",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.155 21.6531C21.9241 21.636 22.688 21.5205 23.4287 21.3094C24.5727 20.9803 25.3138 20.4391 25.3138 19.8467",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3127 16.0436V10.8217",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M25.3354 10.8291V22.8087C25.3354 23.7814 23.5078 24.5713 21.1766 24.6371",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.176 21.0241C17.6675 21.0241 19.6873 20.199 19.6873 19.1811C19.6873 18.1632 17.6675 17.3381 15.176 17.3381C12.6845 17.3381 10.6647 18.1632 10.6647 19.1811C10.6647 20.199 12.6845 21.0241 15.176 21.0241Z",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M19.716 22.1797C19.716 22.7941 18.9965 23.3426 17.8309 23.679C16.9746 23.9131 16.0913 24.0288 15.2046 24.0228C14.3203 24.0293 13.4393 23.9136 12.5857 23.679C11.4416 23.3426 10.6934 22.7941 10.6934 22.1797",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M19.716 19.1811V25.1709C19.716 25.7926 18.9964 26.3338 17.8237 26.6702C16.9706 26.9079 16.0891 27.0236 15.2046 27.0139C14.3202 27.0236 13.4387 26.9079 12.5857 26.6702C11.4416 26.3338 10.6934 25.7926 10.6934 25.1709V19.1811",
  stroke: "#45DB5D",
  strokeLinejoin: "round"
});

var SvgBranchTotalBig = function SvgBranchTotalBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBranchTotalBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/branch-total-big.4ba63ae4.svg";
export { ForwardRef as ReactComponent };